export default {
  key: 'Gb',
  suffix: 'dim',
  positions: [{
    frets: '2020',
    fingers: '2030'
  }, {
    frets: '5653',
    fingers: '2431'
  }, {
    frets: 'b989',
    fingers: '4213'
  }, {
    frets: 'bcec',
    fingers: '1243'
  }]
};